<!-- 머니 정보 -->
<div data-user-popup class="mybalance">
  <div class="mybalance__head">
    <div class="mybalance__title">머니정보</div>
    <a class="mybalance__close" href="#" onclick="$(this).parents('.mybalance').hide(); return false;">닫기</a>
  </div>
  <div class="mybalance__box">
    <div class="mybalance__box-title">
      소지머니
    </div>
    <div class="mybalance__money">
      <span class="icon__money--big"></span>
      <!-- 보유머니 (기존) -->
      {{{moneyTag}}}<strong>&nbsp;골드</strong>
    </div>
  </div>
  <div class="mybalance__box mybalance__box--safe">
    <div class="mybalance__box-title">
      금고머니
    </div>
    <div class="mybalance__money">
      <span class="icon__money--big"></span>
      {{#if hasMoneySafebox}}
      <!-- 보유머니 (기존) -->
      {{{moneyInSafeTag}}}<strong>&nbsp;골드</strong>
      {{else}}
      <!-- 금고 머니 없을 때 -->
      <strong>없음</strong><span class="mybalance__money__move-class">[<a href="#" data-user-action="openMallClass">클래스
          상품보기</a>]</span>
      {{/if}}
    </div>
  </div>
  <div class="mybalance__tail"></div>
</div>
<!-- //mybalance-->